import React from "react";
import { Link } from "react-router-dom";
import "./styles/Footer.scss";
import SponsorsCarousel from "./SponsorsCarousel"; // Import carousel component

const Footer = () => {
  return (
    <>
      <footer className="footer">
        {/* Footer Content */}
        <div className="footer-container">
          <div className="footer-links">
            <div className="footer-column">
              <h4>Who We Are</h4>
              <ul>
                <li>
                  <Link to="/">Music Foundation</Link> {/* Link to Home screen */}
                </li>
                <li>
                  <Link to="/AdvisoryBoard">Our Team</Link> {/* Link to Advisory Board */}
                </li>
                <li>
                  <Link to="/Contact">Partner with us</Link> {/* Link to Contact page */}
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>Learn More</h4>
              <ul>
                <li>
                  <Link to="/success-stories">See Our Impact</Link>
                </li>
                <li>
                  <Link to="/faq">FAQ</Link> {/* Link to FAQ page */}
                </li>
                <li>
                  <Link to="/Contact">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>Resources</h4>
              <ul>
                <li>
                  <Link to="/Donations">Donate</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="social-icons">
              <i className="fab fa-facebook-f"></i>
              <i className="fab fa-twitter"></i>
              <i className="fab fa-instagram"></i>
              <i className="fab fa-youtube"></i>
              <i className="fab fa-vimeo-v"></i>
            </div>
            <div className="footer-details">
              <p>
                Dels Music Foundation is a 501C3 • Tax ID: 13-6089816 •
                <Link to="/Privacy"> Privacy Policy</Link> •
                <Link to="/Terms"> Terms of Use</Link> 
              </p>
            </div>
          </div>
        </div>
        {/* Sponsors Carousel */}
        <div className="sponsors-container">
          <SponsorsCarousel />
        </div>
      </footer>
    </>
  );
};

export default Footer;
